
import { Vue, Options } from 'vue-class-component'
import SvgBase from './SvgBase.vue'
@Options({
  components: {
    SvgBase,
  },
  props: {
    color: {
      type: String,
      default: 'currentColor',
    },
    rotation: {
      type: Number,
      default: 0,
    },
  },
})
export default class IconMore extends Vue {
  get transform() {
    return `transform: rotate(${this.rotation}deg);`
  }
}
